import { fileUrl } from "./api";
import { FALLBACK_THUMB, PLATFORM_THUMB } from "./constants";

// Returns a poster/thumbnail image for a technique (uploaded frame, YouTube thumb, else default per scope)
export function getThumbnail(technique) {
  if (technique?.video_type === "upload" && technique.thumbnail_storage_path) {
    return fileUrl(technique.thumbnail_storage_path);
  }
  if (technique?.video_type === "link" && technique.video_url) {
    const yt = technique.video_url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
    if (yt) return `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg`;
  }
  return technique?.scope === "platform" ? PLATFORM_THUMB : FALLBACK_THUMB;
}

// Returns { type: 'embed'|'file'|'none', src }
export function resolveVideo(technique) {
  if (!technique) return { type: "none", src: "" };
  if (technique.video_type === "upload" && technique.video_storage_path) {
    return { type: "file", src: fileUrl(technique.video_storage_path) };
  }
  if (technique.video_type === "link" && technique.video_url) {
    const embed = toEmbedUrl(technique.video_url);
    if (embed) return { type: "embed", src: embed };
    return { type: "file", src: technique.video_url };
  }
  return { type: "none", src: "" };
}

export function toEmbedUrl(url) {
  if (!url) return null;
  // YouTube (watch, embed, youtu.be, shorts, live)
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;
  // Vimeo
  const vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;
  return null;
}
